/** Up to this many pages every page number is shown; beyond it the list collapses with gaps. */
const MAX_PAGES_WITHOUT_GAPS = 7;
/** Pages shown on each side of the current one when the list collapses. */
const NEIGHBOUR_PAGES = 1;
const FIRST_PAGE = 1;

export type PageItem = number | "gap";

export interface PageWindow {
  pageCount: number;
  /** The requested page, kept within the existing pages. */
  currentPage: number;
  /** Index of the first item on the current page. */
  start: number;
}

function range(from: number, to: number): number[] {
  return Array.from({ length: to - from + 1 }, (_, i) => from + i);
}

/** Page buttons to show: first, last, the current page with its neighbours, and gaps in between. */
export function pageList(current: number, count: number): PageItem[] {
  if (count <= MAX_PAGES_WITHOUT_GAPS) return range(FIRST_PAGE, count);
  const start = Math.max(FIRST_PAGE + 1, current - NEIGHBOUR_PAGES);
  const end = Math.min(count - 1, current + NEIGHBOUR_PAGES);
  const leadingGap: PageItem[] = start > FIRST_PAGE + 1 ? ["gap"] : [];
  const trailingGap: PageItem[] = end < count - 1 ? ["gap"] : [];
  return [FIRST_PAGE, ...leadingGap, ...range(start, end), ...trailingGap, count];
}

/** Which slice of `itemCount` items the requested page shows. */
export function pageWindow(itemCount: number, pageSize: number, requestedPage: number): PageWindow {
  const pageCount = Math.max(FIRST_PAGE, Math.ceil(itemCount / pageSize));
  const currentPage = Math.min(requestedPage, pageCount);
  return { pageCount, currentPage, start: (currentPage - 1) * pageSize };
}
